import React from 'react'
import { withRouter } from 'react-router-dom'
import {Tabs, Tab} from './Tabs'
import SidebarNavigation from './SidebarNavigation'
import Dropdown from './Dropdown'
import constants from '../ndbk-constants'
// import SVGPatterns from './SVGPatterns'

class SettingsPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            info: {
                firstName: '',
                lastName: '',
                email: '',
                avatar: '',
                bio: '',
                visibility: '',
                password: '',
                confirmPassword: '',
                newPassword: ''
            },
            errors: {
                firstName : '',
                lastName: '',
                email: '',
                password: ''
            },
            id: '',
            nodebookSettings: this.props.auth.user.nodebook_settings,
            emailChanged:false
        }
    }

    componentDidMount() {
        document.title = 'Profile settings - ' + constants.WEBSITE_TITLE
        this.fetchProfile()
    }

    fetchProfile = () => {
        fetch(`https://${constants.SERVER_IP}/api/user/id/${this.props.auth.user.id}`,{
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({
                            info: {
                                ...this.state.info,
                                firstName:response.data.first_name,
                                lastName:response.data.last_name,
                                email:response.data.email,
                                avatar:response.data.avatar,
                                bio:response.data.bio,
                                visibility:response.data.visibility
                            }
                        });
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    changeNodebookSettings = (obj) => {
        fetch(`https://${constants.SERVER_IP}/api/change_nodebook_settings`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    nodebookSettings: obj,
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({
                            nodebookSettings: {...this.state.nodebookSettings, ...obj}
                        })
                        this.props.auth.adjustAuthUser({nodebook_settings: {...this.props.auth.user.nodebook_settings, ...obj}})
                    }
                })
            .catch((error) => {
                    console.error(error)
            })
    }

    changePassword = () => {
        if (this.state.info.newPassword !== '' && this.state.info.confirmPassword!== '' && this.state.info.confirmPassword===this.state.info.newPassword) {
            fetch(`https://${constants.SERVER_IP}/api/change_password`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    password: this.state.info.password,
                    newPassword: this.state.info.newPassword
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.setState({
                            info: {
                                password: '',
                                newPassword: '',
                                confirmPassword: ''
                            }
                        })
                    } else {
                        this.setState({errors:{...this.state.errors, password: 'Incorrect password'}})
                    }
                    return response.success
                })
            .catch((error) => {
                    console.error(error)
            })
        } else {
            this.setState({errors:{...this.state.errors, password: 'New password is unacceptable'}})
        }
    }

    updateProfile = () => {
        let hasErrors = false;
        let errors = {
            firstName : '',
            lastName: '',
            email: '',
        }
        if (this.state.info.firstName === '') {
            hasErrors = true;
            errors.firstName = `Can't be empty`
        }
        if (this.state.info.lastName === '') {
            hasErrors = true;
            errors.lastName = `Can't be empty`
        }
        if (this.state.info.email === '') {
            hasErrors = true;
            errors.email = `Can't be empty`
        }
        if (!hasErrors) {
            this.setState({errors: {...this.state.errors, ...errors}})
            fetch(`https://${constants.SERVER_IP}/api/user/update`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    firstName: this.state.info.firstName,
                    lastName: this.state.info.lastName,
                    email: this.state.info.email,
                    bio: this.state.info.bio,
                    avatar: this.state.info.avatar,
                    visibility: this.state.info.visibility,
                    id: this.state.id
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    this.props.history.push(`/user/${this.props.auth.user.username}`)
                    return response.success;
                })
            .catch((error) => {
                    console.error(error)
            })
        } else {
            this.setState({errors: {...this.state.errors, ...errors}})
        }
    }

    onFileInput = (files) => {
        var file=files[0]
        const reader = new FileReader();
            reader.onload = () => {
                //const fileAsBinaryString = reader.result;
                        var formData = new FormData();
                        formData.append('profile_image', file)
                        fetch(`https://${constants.SERVER_IP}/api/upload_profile_picture`, {
                            method: 'POST',
                            body: formData,
                            credentials: 'include',
                        })
                            .then((response)=>response.json())
                            .then((response)=>{
                                if (response.success) {
                                    this.fetchProfile();
                                }
                            })
                            .catch((err)=>
                            {
                            })
            };
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.readAsBinaryString(file);
    }

    render() {
        var selectedTab = (['profile', 'security' ].indexOf(this.props.match.params.tab) !== -1)?this.props.match.params.tab:'profile'

        return (
            <div className="main">

                <SidebarNavigation {...this.props}/>

                <div className="main-content">

                    <Tabs
                        selectedTab={selectedTab}
                        onChangeTab={selectedTab => {
                            this.props.history.push(`/settings/${selectedTab}`)
                        }} >
                        <Tab name="profile" title="Profile">
                            <div className="container-fluid">
                                <div className="row settings">
                                    <div className="col-lg-2 col-sm-12">
                                        <label className="settings-profile-avatarpicker">
                                            <img src={this.state.info.avatar} alt="" />
                                            <input type="file" multiple={false} accept= "image/*" onChange={ (e) => this.onFileInput(e.target.files) }/>
                                        </label>
                                    </div>
                                    <div className="col-lg-10 col-sm-12">
                                        <div className="basic">
                                            <label>First name:</label>
                                            <input
                                                type="text"
                                                placeholder="First name"
                                                value={this.state.info.firstName}
                                                onChange={e=>this.setState({info: {...this.state.info, firstName: e.target.value }})}
                                                spellCheck="false"
                                            />
                                        </div>
                                        <div className="basic">
                                            <label>Last name:</label>
                                            <input
                                                type="text"
                                                placeholder="Family name"
                                                value={this.state.info.lastName}
                                                onChange={e=>this.setState({info: {...this.state.info, lastName: e.target.value }})}
                                                spellCheck="false"
                                            />
                                        </div>
                                        <div className="basic email" title="Only you can see this">
                                            <label>Email:</label>
                                            <div className="email">{this.state.info.email}</div>
                                        </div>
                                        <label>Bio:</label>
                                        <textarea
                                            placeholder="Describe yourself here!"
                                            value={this.state.info.bio || ''}
                                            onChange={e=>this.setState({info: {...this.state.info, bio: e.target.value }})}
                                            spellCheck="false"
                                        />
                                        <br/>
                                        <span className="save" onClick={()=>{this.updateProfile();}}>
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                <path d="M9.5 20c-2.538 0-4.923-0.988-6.718-2.782s-2.782-4.18-2.782-6.717c0-2.538 0.988-4.923 2.782-6.718s4.18-2.783 6.718-2.783c2.538 0 4.923 0.988 6.718 2.783s2.782 4.18 2.782 6.718-0.988 4.923-2.782 6.717c-1.794 1.794-4.18 2.782-6.718 2.782zM9.5 2c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5z"></path>
                                                <path d="M7.5 14.5c-0.128 0-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2.646 2.646 6.646-6.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-7 7c-0.098 0.098-0.226 0.146-0.354 0.146z"></path>
                                            </svg>
                                            Update profile
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                         <Tab name="security" title="Security">
                            <div className="container-fluid">
                                <div className="row settings">
                                    <div className="col-lg-4">
                                    </div>
                                    <div className="col-lg-12">
                                        <h4>Profile visibility</h4>
                                        <span className="save"
                                            onClick={e=>
                                                this.setState(
                                                    {info: { ...this.state.info, visibility: (this.state.info.visibility==='public') ? 'private': 'public'}},
                                                    this.updateProfile
                                                )
                                            }>
                                            {(this.state.info.visibility === 'public')?'Public':'Private'}
                                        </span>
                                        <br/><br/>
                                        <h4>Change password</h4>
                                        <input
                                            type="password"
                                            value={this.state.info.password}
                                            onChange={e=>this.setState({info: {...this.state.info, [e.target.name]: e.target.value }})}
                                            name="password"
                                            placeholder="Current password"
                                        />
                                        <input
                                            type="password"
                                            value={this.state.info.newPassword}
                                            onChange={e=>this.setState({info: {...this.state.info, [e.target.name]: e.target.value }})}
                                            name="newPassword"
                                            placeholder="New password"
                                        />
                                        <input
                                            type="password"
                                            value={this.state.info.confirmPassword}
                                            onChange={e=>this.setState({info: {...this.state.info, [e.target.name]: e.target.value }})}
                                            name="confirmPassword"
                                            placeholder="Confirm new password"
                                        />
                                        <span className="save" onClick={()=>{this.changePassword();}}>
                                            Change password
                                        </span>
                                        <br/>
                                        {this.state.errors.password}
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        {/*<Tab name="appearance" title="Appearance">
                            <div className="container-fluid">
                                <div className="row settings">
                                    <div className="col-lg-12">
                                        <h3 className="block-title">Nodebook background pattern</h3>
                                    </div>
                                    {
                                        ['none','tiles','topography','grid','hexagon','temple','circuit','curtain'].map(
                                            bgName => (
                                                <div className="col-lg-3 col-md-6" key={bgName}>
                                                    <div
                                                        className={`settings-ndbkbg nodebook-svg ${this.state.nodebookSettings.pattern===bgName?'selected':''}`}
                                                        onClick={()=>{this.changeNodebookSettings({pattern: bgName})}}
                                                        style={{backgroundImage: SVGPatterns[bgName](this.state.nodebookSettings.color)}}
                                                    ></div>
                                                </div>
                                            )
                                        )
                                    }
                                    <div className="col-lg-12">
                                        <label>Pattern color:</label>
                                        <input
                                            type="text"
                                            value={this.state.nodebookSettings.color}
                                            spellCheck="false"
                                            onChange={e=>{
                                                this.changeNodebookSettings({color: e.target.value})
                                            }}
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <h3 className="block-title">Theme</h3>
                                        <h4><s style={{color: '#aaa', fontWeight: 100}}>Bright &middot; Dark &middot; Neon</s></h4>
                                    </div>
                                </div>
                            </div>
                        </Tab>*/}

                        {
                        //region Deprecated tabs
                        // <Tab name="notifications" title="Notifications">
                        //  <div className="container-fluid">
                        //      <div className="row">
                        //          <div className="col-lg-6">
                        //              <div className="settings-notifications-group">
                        //                  <div className="settings-notifications-group-body">
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">Notification sound</p>
                        //                          <input type="checkbox" className="special" />
                        //                      </div>
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">Show desktop notifications</p>
                        //                          <input type="checkbox" className="special" />
                        //                      </div>
                        //                  </div>
                        //              </div>

                        //              <div className="settings-notifications-group">
                        //                  <div className="settings-notifications-group-head">
                        //                      <p className="settings-notifications-group-head-title">you</p>
                        //                      <span>Email</span>
                        //                      <span>On site</span>
                        //                  </div>
                        //                  <div className="settings-notifications-group-body">
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">New follower</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">Mention in nodebook comment</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                  </div>
                        //              </div>

                        //              <div className="settings-notifications-group">
                        //                  <div className="settings-notifications-group-head">
                        //                      <p className="settings-notifications-group-head-title">your nodebooks</p>
                        //                      <span>Email</span>
                        //                      <span>On site</span>
                        //                  </div>
                        //                  <div className="settings-notifications-group-body">
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">Comments</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">Likes</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                  </div>
                        //              </div>
                        //          </div>
                        //          <div className="col-lg-6">
                        //              <div className="settings-notifications-group">
                        //                  <div className="settings-notifications-group-head">
                        //                      <p className="settings-notifications-group-head-title">people you follow</p>
                        //                      <span>Email</span>
                        //                      <span>On site</span>
                        //                  </div>
                        //                  <div className="settings-notifications-group-body">
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">new nodebook</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">nodebook update</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                  </div>
                        //              </div>

                        //              <div className="settings-notifications-group">
                        //                  <div className="settings-notifications-group-head">
                        //                      <p className="settings-notifications-group-head-title">nodebooks you follow</p>
                        //                      <span>Email</span>
                        //                      <span>On site</span>
                        //                  </div>
                        //                  <div className="settings-notifications-group-body">
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">nodebook update</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                      <div className="settings-notifications-group-notification">
                        //                          <p className="settings-notifications-group-notification-title">new node</p>
                        //                          <input type="checkbox" />
                        //                          <input type="checkbox" />
                        //                      </div>
                        //                  </div>
                        //              </div>
                        //          </div>
                        //      </div>
                        //  </div>
                        // </Tab>
                        // <Tab name="themes" title="Themes">
                        //  <div className="container-fluid">
                        //      <div className="row">
                        //          <div className="col-lg-12">
                        //              <p>themes</p>
                        //          </div>
                        //      </div>
                        //  </div>
                        // </Tab>
                        // <Tab name="plugins" title="Plugins">
                        //  <div className="container-fluid">
                        //      <div className="row">
                        //          <div className="col-lg-12">
                        //              <p>plugins</p>
                        //          </div>
                        //      </div>
                        //  </div>
                        // </Tab>
                        //endregion
                        }
                    </Tabs>

                </div>

            </div>
        );
    }
}

export default withRouter(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/SettingsPage.js